import { useQuery } from '@tanstack/react-query';
import { getUserSession } from '../../../../../../util/core/Session';
import config from '../../../../../../config/config';
import Fetch from '../../../../../../../core/util/core/Fetch';

const useCities = () => {
    const session = getUserSession();

    const profile = session.user.application_profile_id;

    const isAdm = profile === config.default_foreign_key.profiles.zellusAdmin;

    const isClientManager =
        profile === config.default_foreign_key.sdg_profiles.clientManager;

    return useQuery({
        queryKey: ['cities-dashboard'],
        queryFn: async () => {
            const filters = {
                core_application_instance_id: isAdm
                    ? null
                    : session.loggedUserInfo.application_instance_id
            };

            const cities = await Fetch.post(
                config.endpoints.backend +
                'governanceroom/dashboardsamu/cities',
                {
                    filters
                }
            );

            const citiesMapped = cities.map((city) => ({
                label: city.cidade,
                value: city.city_id
            }));

            const citiesNotRepeated = new Set();
            const citiesFiltered = citiesMapped.filter((city) => {
                if (citiesNotRepeated.has(city.value)) {
                    return false;
                }
                citiesNotRepeated.add(city.value);
                return true;
            });

            return citiesFiltered || [];
        },
        enabled: true,
    });
};

export default useCities;
